import React from 'react';
export function IdentificationSection() {
  const quotes = ['"Sé que tengo que soltar, pero no puedo. Y eso me da más rabia que lo que estoy tratando de soltar."', '"Racionalmente entiendo todo. Emocionalmente sigo igual. Hay días buenos y de repente algo me lo recuerda."', '"Fui a terapia, leí libros, hice afirmaciones. Me ayudaron a entender, pero no sentí que algo cerrara de verdad."', '"Quiero que eso sea parte de mi historia. Pero no quiero que sea toda mi historia."'];
  return <section id="identification" className="py-12 md:py-16 text-center" style={{
    background: 'var(--blush)'
  }} data-id="element-163">
      <div className="max-w-[960px] mx-auto px-5" data-id="element-164">
        <h2 className="font-serif font-normal max-w-[580px] mx-auto mb-3" style={{
        fontSize: 'clamp(24px, 4vw, 40px)',
        color: 'var(--ink)'
      }} data-id="element-165">
          ¿Alguna de estas frases
          <br data-id="element-166" />
          <em style={{
          color: 'var(--rose-deep)'
        }} data-id="element-167">
            te suena demasiado familiar?
          </em>
        </h2>

        <p className="text-[15px] max-w-[480px] mx-auto mb-8" style={{
        color: 'var(--muted)',
        lineHeight: 1.6
      }} data-id="element-168">
          Si algo de esto resuena en vos,{' '}
          <strong style={{
          color: 'var(--ink)',
          fontWeight: 500
        }} data-id="element-169">
            este kit fue diseñado exactamente para donde estás parada hoy
          </strong>
          .
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-left" data-id="element-170">
          {quotes.map((quote, index) => <div key={index} className="fade-in p-5 px-5 rounded-r-lg" style={{
          background: 'var(--white)',
          border: '1px solid var(--blush-mid)',
          borderLeft: '3px solid var(--rose)'
        }} data-id="element-171">
              <p className="font-serif text-[15px] italic leading-relaxed" style={{
            color: 'var(--ink-soft)'
          }} data-id="element-172">
                {quote}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}